var map = {
	"./Godrej-logo.jpg": 5964,
	"./VANM PLY.jpg": 1611,
	"./aaryan hardware.jpeg": 3581,
	"./advance laminates.jpg": 1525,
	"./cent veneer.jpg": 9364,
	"./centurylogo.jpg": 1539,
	"./durian.png": 7729,
	"./ebco.png": 8865,
	"./fevicol.png": 3136,
	"./godrej.jpg": 2641,
	"./merino laminates.jpg": 9210,
	"./royal touche logo.jpg": 4721,
	"./ultima.jpeg": 4346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5953;